/**
 * Assigning multiple refs to a component.
 * reference: https://www.davedrinks.coffee/how-do-i-use-two-react-refs/
 *
 * @param refs list of refs
 */

export const mergeRefs = <T>(
  ...refs: Array<((instance: T | null) => void) | React.MutableRefObject<T | null> | null>
) => {
  const filteredRefs = refs.filter(Boolean);

  if (!filteredRefs.length) return null;
  if (filteredRefs.length === 0) return filteredRefs[0];

  return (inst: T | null) => {
    for (const ref of filteredRefs) {
      if (typeof ref === 'function') {
        (ref as (param: T | null) => void)(inst);
      } else if (ref) {
        ref.current = inst;
      }
    }
  };
};
